import React from 'react'
import { jt, t } from 'ttag'

import { CopyTemplateModal } from 'components/modals/common/CopyTemplateModal/CopyTemplateModal'

import { useCopyTemplateModal } from 'components/modals/common/CopyTemplateModal/hooks'

export const CopyInterviewTemplateModal = ({
  template,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useCopyTemplateModal({
    onCancel,
    onClose,
    onConfirm,
  })

  const { copy } = state
  const { handleCancel, handleClose, handleConfirm } = handlers

  const title = template?.title

  const message = (
    <strong key="template">{t`based on ${title} template`}</strong>
  )

  return (
    <CopyTemplateModal
      alert={jt`You are creating a new interview template ${message}.`}
      form={copy}
      label={t`Interview template name`}
      title={t`Copy interview template`}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      {...{ isOpen }}
    />
  )
}
